module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-bar-container"
  }, [_c('div', {
    staticClass: "main-text"
  }, [_vm._v("Feature content")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-4 mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature-flex"
  }, [_c('div', {
    staticClass: "w-75"
  }, [_c('div', {
    staticClass: "feature-head mb-3"
  }, [_vm._v("Web description")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-feature"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webTitle),
      expression: "webTitle"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "46"
    },
    domProps: {
      "value": (_vm.webTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-feature mt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webReview),
      expression: "webReview"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.webReview)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webReview = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-head mb-3 mt-5"
  }, [_vm._v("Mobile description")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-feature"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileTitle),
      expression: "mobileTitle"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "26"
    },
    domProps: {
      "value": (_vm.mobileTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-feature mt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileReview),
      expression: "mobileReview"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.mobileReview)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileReview = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-25"
  }, [_c('div', {
    staticClass: "feature-head mb-3"
  }, [_vm._v("Content Image")]), _vm._v(" "), _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.album.cover.url,
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-4 mb-5"
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "post-content",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.saveTitleAndReview()
      }
    }
  }, [_vm._v("\n\t\t \tPost Content\n\t\t")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Title for Web")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*46 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Review for web")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*120 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Title for mobile")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*26 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Review for mobile")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*60 chars max")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19891cf6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/featureModal/index.vue
// module id = 1630
// module chunks = 180